export default __webpack_public_path__ + "static/media/astronaut.3a7677db.svg";